import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    feedbackCardBody:
        "Αξιολόγησε γεύματα, παράδοση και την εφαρμογή — χρειάζεται λιγότερο από ένα λεπτό.",
    languageLabel: "Γλώσσα",
    termsConditions: "Όροι χρήσης",
    privacyPolicy: "Πολιτική απορρήτου",
    cookiesPolicy: "Πολιτική Cookies",
    howItWorks: "Πώς λειτουργεί",
    logoutCardBody:
        "Δεν χρειάζεται να αποσυνδεθείς για να αλλάξεις μεταξύ Δημοτικού και Γυμνασίου. Αν έχεις συνδεθεί και στα δύο, μπορείς να το κάνεις από την επιλογή σχολείου πάνω αριστερά.",
    logoutCardBodyMobile:
        "Δεν χρειάζεται να αποσυνδεθείς για να αλλάξεις μεταξύ Δημοτικού και Γυμνασίου. Αν έχεις συνδεθεί και στα δύο, μπορείς να το κάνεις από την επιλογή σχολείου στο πλαϊνό μενού.",
    logout: "Αποσύνδεση",
    unregister: "Διαγραφή",
    signOutDlgTitle: "Αποσύνδεση",
    dlgDeleteAccount:
        "Είσαι σίγουρος/η; Όλα τα δεδομένα σου θα διαγραφούν και δεν θα μπορείς να τα ανακτήσεις",
    dlgAccountDeleted:
        "Ο λογαριασμός σου και όλα τα δεδομένα έχουν διαγραφεί",
};

const en: typeof el = {
    feedbackCardBody:
        "Rate meals, delivery, and the app — it takes less than a minute.",
    languageLabel: "Language",
    termsConditions: "Terms & Conditions",
    privacyPolicy: "Privacy Policy",
    cookiesPolicy: "Cookies Policy",
    howItWorks: "How it works",
    logoutCardBody:
        "You don't need to log out to switch between lower and upper school. If you've signed in to both, use the school dropdown in the top-left corner.",
    logoutCardBodyMobile:
        "You don't need to log out to switch between lower and upper school. If you've signed in to both, use the school dropdown in the side menu.",
    logout: "Logout",
    unregister: "Unregister",
    signOutDlgTitle: "Sign out",
    dlgDeleteAccount:
        "Are you sure? All your data will be permanently lost",
    dlgAccountDeleted:
        "Your account and all of your data have been successfully removed",
};

const settingsLangs = { el, en };

export function useSettingsStrings() {
    const [lang] = useContext(langContext);
    return settingsLangs[lang];
}
